module.exports = __webpack_public_path__ + "static/media/slovacka.90e1cf10.md";